import { IconProps } from './icons-props';

function TermsAndConditionsIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M17.62 9.62012H12.37C11.96 9.62012 11.62 9.28012 11.62 8.87012C11.62 8.46012 11.96 8.12012 12.37 8.12012H17.62C18.03 8.12012 18.37 8.46012 18.37 8.87012C18.37 9.28012 18.04 9.62012 17.62 9.62012Z'
                fill='currentColor'
            />
            <path
                d='M7.12006 10.3798C6.93006 10.3798 6.74006 10.3098 6.59006 10.1598L5.84006 9.40982C5.55006 9.11982 5.55006 8.63982 5.84006 8.34982C6.13006 8.05982 6.61006 8.05982 6.90006 8.34982L7.12006 8.56982L8.84006 6.84982C9.13006 6.55982 9.61006 6.55982 9.90006 6.84982C10.1901 7.13982 10.1901 7.61982 9.90006 7.90982L7.65006 10.1598C7.51006 10.2998 7.32006 10.3798 7.12006 10.3798Z'
                fill='currentColor'
            />
            <path
                d='M17.62 16.6201H12.37C11.96 16.6201 11.62 16.2801 11.62 15.8701C11.62 15.4601 11.96 15.1201 12.37 15.1201H17.62C18.03 15.1201 18.37 15.4601 18.37 15.8701C18.37 16.2801 18.04 16.6201 17.62 16.6201Z'
                fill='currentColor'
            />
            <path
                d='M7.12006 17.3798C6.93006 17.3798 6.74006 17.3098 6.59006 17.1598L5.84006 16.4098C5.55006 16.1198 5.55006 15.6398 5.84006 15.3498C6.13006 15.0598 6.61006 15.0598 6.90006 15.3498L7.12006 15.5698L8.84006 13.8498C9.13006 13.5598 9.61006 13.5598 9.90006 13.8498C10.1901 14.1398 10.1901 14.6198 9.90006 14.9098L7.65006 17.1598C7.51006 17.2998 7.32006 17.3798 7.12006 17.3798Z'
                fill='currentColor'
            />
            <path
                d='M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default TermsAndConditionsIcon;

